import React from 'react'

import Layout from '../../components/Layout'

const ContractValidity = () => {
	return (
		<Layout
			headerMode='fixed'
			title='Durante la Vigencia del Contrato'
			description='Negociamos periódicamente el aumento de los alquileres de acuerdo a los incrementos pactados en el contrato.'>
			<section className='contract-validity benefit-section fader'>
				<h2 className='benefit-section__title'>Durante la Vigencia del Contrato</h2>
				<div className='benefit-section__content'>
					<h3>Aumento periódico del alquiler</h3>
					<p>
						Negociamos periódicamente el aumento de los alquileres de acuerdo a los incrementos
						pactados en el contrato (ESTO SÓLO SERÁ POSIBLE EN LOS CONTRATOS COMERCIALES, NO EN LOS
						DESTINADOS A VIVIENDA FAMILIAR, DONDE ES LA LEY LA QUE ESTABLECE EL ÍNDICE ANUAL A TENER
						EN CUENTA)
					</p>

					<h3>Despersonalización en el trato inquilino - propietario</h3>
					<p>
						Evitando el contacto personal del propietario con el inquilino “durante la vigencia del
						contrato” se disuaden potenciales abusos de confianza y se neutralizan las disputas
						entre las partes, optimizándose al máximo el cumplimiento del contrato y de la ley, en
						un ambiente cordial.
					</p>

					<h3>Cobranza rigurosa de alquileres y punitorios</h3>
					<p>Cobramos el alquiler y si surgen atrasos cobramos punitorios.</p>

					<h3>Control de expensas, impuestos y servicios</h3>
					<p>
						Controlamos día por día el pago de expensas, impuestos y servicios. Pedimos a los
						inquilinos la debida presentación de los comprobantes originales de pago de expensas,
						impuestos y servicios. Es importante el pago de dichas cargas ya que su atraso continuo
						acarrea desorden y pérdidas en la rentabilidad.
					</p>

					<h3>Rendiciones de cuentas mensuales al propietario</h3>
					<p>Las rendiciones al propietario están informatizadas y detallan:</p>

					<ul>
						<li>Ingresos, egresos, punitorios, gastos.</li>

						<li>Entrega de comprobantes de pago de impuestos, servicios y expensas.</li>
					</ul>

					<h3>Forma de pago a los propietarios</h3>
					<p>
						El cliente elige. Puede cobrar en efectivo en nuestras oficinas. O podemos transferirlo
						o depositarlo en la cuenta bancaria que usted nos indique.
					</p>

					<h3>Exclusivo programa informático de administración de alquileres.</h3>
					<p>
						Tenemos un nuevo Programa donde se sistematizó todos nuestros métodos y acciones.
						Nuestro Equipo actualiza continuamente la información para que esté disponible.
					</p>
				</div>
			</section>
		</Layout>
	)
}

export default ContractValidity
